module.exports = __webpack_public_path__ + "static/media/edit-button-orange.afb55623.svg";